// extracted by mini-css-extract-plugin
export default {"expiredLongTermMedication":"PatientMedicationGrid_expiredLongTermMedication__BLj8f","spanSlashSpacing":"PatientMedicationGrid_spanSlashSpacing__xo7P1"};